import React from "react";
import "./Copyright.scss";

const Copyright = () => {
  return (
    <section className="copyright-section">
      <div className="container">
        <div className="copyright">Copyright © {new Date().getFullYear()} D.Vision SIA. All rights reserved.<br />Powered by D.Vision. Made in the EU.</div>
      </div>
    </section>
  );
};

export default Copyright;
